module.exports = __webpack_public_path__ + "static/media/QuestionMark.aa7bbefe.svg";